import React from 'react';
import './ITSoftware.css';

function Education() {
  return (
    <div className="service-page">
      {/* Hero Section */}
      <section
        className="hero-image-section"
        style={{ backgroundImage: "url('/images/education_hero.png')" }}
      >
        <div className="hero-text-container">
          <h1>Education</h1>
          <p>Financial & legal support for schools, ed-tech startups, training institutes and NGOs</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="service-content">
        <div className="content-left">
          <h2>Shaping Learning With Strategic Compliance</h2>
          <p>We assist schools, coaching centers, and e-learning companies with tax, audit, and licensing formalities.</p>
          <p>Our experts handle trust registration, FCRA compliance, and online course monetization planning.</p>
          <p>Whether you run a private school or an online ed-tech platform, we help align your business and compliance models.</p>
          <p>We also support curriculum creators and educational NGOs in structuring grants and donor documentation.</p>
        </div>
        <div className="content-right">
          <img src="/images/education.jpg" alt="Education Industry" />
        </div>
      </section>
    </div>
  );
}

export default Education;
